module.exports = __webpack_public_path__ + "static/media/health-slow.de1d2271.mp3";